// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapper_root__3zr9z"};